"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=create_tuple.js.map